import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/crossgate.tw',
      name: 'crossgate.tw',
      component: () => import('@/route/src/index.vue'),
      meta: {
        component: 'CrossgateTw',
        title: '魔力寶貝'
      },
      children: [
        {
          path: '/crossgate.tw/policy',
          name: 'crossgate.policy',
          component: () => import('@/route/src/index.vue'),
          meta: {
            component: 'Policy',
            title: '魔力寶貝'
          }
        },
        {
          path: '/crossgate.tw/terms',
          name: 'crossgate.terms',
          component: () => import('@/route/src/index.vue'),
          meta: {
            component: 'Terms',
            title: '魔力寶貝'
          }
        },
      ]
    },
    {
      path: '/crossgate.tw/prereg',
      name: 'crossgate.prereg',
      component: () => import('../route/src/prereg/index.vue'),
      meta: {
        component: 'Activity01',
        title: '《魔力寶貝：冒險新天團》事前預約中｜預約就送黃阿瑪聯動寵物&時裝'
      }
    },
    {
      path: '/',
      name: 'lingliu',
      component: () => import('@/route/src/index.vue'),
      meta: {
        component: 'Lingliu',
        title: 'Lingluk Game'
      },
      children: [
        {
          path: '/policy',
          name: 'lingliu.policy',
          component: () => import('@/route/src/index.vue'),
          meta: {
            component: 'LingliuPolicy',
            title: 'Lingluk Game'
          }
        },
        {
          path: '/terms',
          name: 'lingliu.terms',
          component: () => import('@/route/src/index.vue'),
          meta: {
            component: 'LingliuTerms',
            title: 'Lingluk Game'
          }
        },
      ]
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/route/src/index.vue'),
      meta: {
        component: 'index'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js